import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, getLinkTo, title, groups } = appSections.settings;
export const settingsRoute = {
    path: rootPath,
    lazy: async () => {
        const { Settings } = await import('@/warehouse/modules/settings');
        return {
            element: (_jsx(ProtectedRoute, { groups: groups, children: _jsx(Settings, {}) })),
        };
    },
    handle: {
        crumb: () => _jsx(NavLink, { to: getLinkTo(''), children: title }),
    },
};
